/* eslint-disable react/no-unknown-property */
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Reveal } from "./Reveal";

export default function BookPage() {
  // Third-party (Gymdesk / jQuery) uncaught errors are contained by an
  // early inline listener in public/index.html so they can't stack into the
  // dev overlay — that filter must be registered before the app bundle to
  // beat react-error-overlay's handler.

  useEffect(() => {
    const JQUERY_SRC = "https://code.jquery.com/jquery-3.7.1.min.js";
    const GYMDESK_SRC = "https://app.gymdesk.com/js/widgets.js";

    const ensureScript = (src, key) =>
      new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[data-widget="${key}"]`);
        if (existing) {
          if (existing.dataset.loaded === "true") return resolve();
          existing.addEventListener("load", () => resolve(), { once: true });
          existing.addEventListener("error", reject, { once: true });
          return;
        }
        const s = document.createElement("script");
        s.src = src;
        s.async = false; // preserve execution order (jQuery before Gymdesk)
        s.dataset.widget = key;
        s.addEventListener(
          "load",
          () => {
            s.dataset.loaded = "true";
            resolve();
          },
          { once: true }
        );
        s.addEventListener("error", reject, { once: true });
        document.body.appendChild(s);
      });

    let cancelled = false;
    (async () => {
      try {
        // Gymdesk widgets.js requires jQuery ($) to be defined at eval time.
        // Preload it exactly once, then (re)inject the Gymdesk widget so it
        // scans the current DOM for .gymdesk-booking on each /book visit.
        await ensureScript(JQUERY_SRC, "jquery");
        if (cancelled) return;
        document
          .querySelectorAll(`script[data-widget="gymdesk"]`)
          .forEach((s) => {
            if (s.parentNode) s.parentNode.removeChild(s);
          });
        const gs = document.createElement("script");
        gs.src = GYMDESK_SRC;
        gs.async = true;
        gs.dataset.widget = "gymdesk";
        document.body.appendChild(gs);
      } catch (_) {
        /* third-party script failed to load — leave the container empty */
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <section
          className="relative bg-ink pt-36 pb-24 md:pt-44 md:pb-36 px-6 lg:px-10 overflow-hidden min-h-screen"
          data-testid="book-page"
        >
          {/* accent glow — consistent with booking section */}
          <div className="pointer-events-none absolute -top-40 right-0 h-[500px] w-[500px] rounded-full bg-hotpink/10 blur-[120px]" />
          <div className="pointer-events-none absolute -bottom-40 left-0 h-[500px] w-[500px] rounded-full bg-teal/10 blur-[120px]" />

          <div className="relative mx-auto max-w-[900px]">
            <Reveal>
              <p className="font-body text-xs md:text-sm uppercase tracking-[0.3em] text-teal mb-6">
                / First Class On Us
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <h1 className="font-display font-700 uppercase leading-[0.88] tracking-tighter text-white text-5xl md:text-6xl lg:text-7xl">
                Book your <span className="text-stroke-pink">free</span> class
              </h1>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-xl font-body text-base md:text-lg text-neutral-300 leading-relaxed">
                Everyone starts somewhere. Choose a time below and we&apos;ll see
                you on the mats.
              </p>
            </Reveal>

            <Reveal delay={0.25}>
              <div className="mt-12 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-4 md:p-6">
                <div
                  className="gymdesk-booking"
                  attr-gym="ApMQR"
                  attr-schedule="all"
                  attr-form="6X2ey"
                ></div>
              </div>
            </Reveal>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
